import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {SessionService} from '../../../services/local/session/session.service';
import {Observable} from 'rxjs';

@Injectable()
export class LinGuard implements CanActivate {

  constructor(private sessionService: SessionService, private router: Router) {
  };

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.sessionService.isLinUser()) {
      this.router.navigateByUrl('app/customer/start/startpage');
      return false;
    }
    return true;
  }
}
